import {
  GET_ADMIN_VIEW_INFO,
  UPDATE_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION,
  OPEN_FORCE_LOGOUT_DIALOG,
  GET_ALL_USER_ROLES,
  GET_ALL_COMPANIES,
} from '../constants/ActionTypes'
import {
  GET_ADMIN_VIEW_INFO_QUERY,
  UPDATE_SUBSCRIPTION_QUERY,
  CREATE_SUBSCRIPTION_QUERY,
  DELETE_SUBSCRIPTION_QUERY,
  GET_ALL_USER_ROLES_QUERY,
  ALL_COMPANIES_QUERY,
  ADMIN_CREATE_USER_QUERY,
  UPDATE_USER_QUERY,
} from '../constants/QueryTypes'
import { hasUserSessionError } from '../helpers/errorHandler'
import query from '../services/GraphQLService'

export const getAllUsersSubscriptions = () => (dispatch) => {
  query('query', GET_ADMIN_VIEW_INFO_QUERY, {}).then(({ data, errors }) => {
    if (errors && hasUserSessionError(errors)) {
      // dispatch({ type: OPEN_FORCE_LOGOUT_DIALOG })
      return
    }
    dispatch({ type: GET_ADMIN_VIEW_INFO, payload: data })
  })
}

export const getAllUserRoles = () => (dispatch) => {
  query('query', GET_ALL_USER_ROLES_QUERY, {}).then(({ data, errors }) => {
    if (errors && hasUserSessionError(errors)) {
      // dispatch({ type: OPEN_FORCE_LOGOUT_DIALOG })
      return
    }
    dispatch({ type: GET_ALL_USER_ROLES, payload: data })
  })
}

export const updateSubscription = (id, city_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    query('mutate', UPDATE_SUBSCRIPTION_QUERY, { id, city_id })
      .then(({ data, errors }) => {
        if (errors && hasUserSessionError(errors)) {
          // dispatch({ type: OPEN_FORCE_LOGOUT_DIALOG })
          reject(errors)
          return
        }
        dispatch({
          type: UPDATE_SUBSCRIPTION,
          payload: data.updateSubscription,
        })
        resolve(data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

export const createSubscription = (company_id, city_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    query('mutate', CREATE_SUBSCRIPTION_QUERY, { company_id, city_id })
      .then(({ data, errors }) => {
        if (errors && hasUserSessionError(errors)) {
          // dispatch({ type: OPEN_FORCE_LOGOUT_DIALOG })
          reject(errors)
          return
        }
        dispatch({
          type: CREATE_SUBSCRIPTION,
          payload: data.createSubscription,
        })
        resolve(data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

export const deleteSubscription = (company_id, city_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    query('mutate', DELETE_SUBSCRIPTION_QUERY, { company_id, city_id })
      .then(({ data, errors }) => {
        if (errors && hasUserSessionError(errors)) {
          // dispatch({ type: OPEN_FORCE_LOGOUT_DIALOG })
          reject(errors)
          return
        }
        dispatch({
          type: DELETE_SUBSCRIPTION,
          payload: data.deleteSubscription,
        })
        resolve(data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

export const getAllCompanies = () => (dispatch) => {
  return query('query', ALL_COMPANIES_QUERY, {}).then(({ data, errors }) => {
    if (errors && hasUserSessionError(errors)) {
      return
    }
    dispatch({ type: GET_ALL_COMPANIES, payload: data })
  })
}

export const adminCreateUser =
  (
    company_id,
    firstName,
    lastName,
    email,
    phone,
    occupation,
    role_id,
    isPrimaryContact
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      query('mutate', ADMIN_CREATE_USER_QUERY, {
        company_id,
        firstName,
        lastName,
        email,
        phone,
        occupation,
        role_id,
        isPrimaryContact,
      })
        .then(({ data, errors }) => {
          if (errors && hasUserSessionError(errors)) {
            reject(errors)
            return
          }
          resolve(data.adminCreateUser)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

export const adminUpdateUser =
  (
    id,
    firstName,
    lastName,
    occupation,
    email,
    phone,
    role_id,
    company_id,
    isPrimaryContact
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      query('mutate', UPDATE_USER_QUERY, {
        id,
        firstName,
        lastName,
        occupation,
        email,
        phone,
        role_id,
        company_id,
        isPrimaryContact,
      })
        .then(({ data, errors }) => {
          if (errors && hasUserSessionError(errors)) {
            reject(errors)
            return
          }
          resolve(data.updateUser)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
